import Icon from "@ui-kit/icons/Icon.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Text from "@ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";
import { ItemVisibilityProps } from "./ItemVisibility.props";

const ItemVisibility = ({
  isLimitedVisibility,
  isAccessible,
}: ItemVisibilityProps) => {
  const { t } = useTranslation("seating");

  return (
    <>
      <Flex
        color="gray.600"
        hidden={!isLimitedVisibility}
        mb="2xs"
        alignItems="center"
      >
        <Icon.Info color="gray.600" boxSize="element.sm" mr="2xs" />
        <Text fontSize="xs">{t("Limited Visibility")}</Text>
      </Flex>
      <Flex
        color="gray.600"
        hidden={!isAccessible}
        mb="2xs"
        alignItems="center"
      >
        <Icon.Info color="gray.600" boxSize="element.sm" mr="2xs" />
        <Text fontSize="xs">{t("Accessible")}</Text>
      </Flex>
    </>
  );
};

export default ItemVisibility;
